module.exports = __webpack_public_path__ + "static/img/20013 (3).32d0bb5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20013 (3).webp
// module id = u5Um
// module chunks = 14